module.exports = __webpack_public_path__ + "img/pied-piper.764a1a08.svg";